import React from "react";
import HeroMobile from "../HeroMobile";

/**
 * Mobile-only Home:
 * - Floating language toggle INSIDE the hero
 * - CTAs moved OUTSIDE the hero (just below it)
 * - Feature cards after CTAs
 */
export default function MobileHome({ t, dir, routes, UI, lang, setLang }) {
  const onToggleLang = () => {
    const next = lang === "ar" ? "en" : "ar";
    try { localStorage.setItem("granada_lang", next); } catch {}
    setLang(next);
  };

  return (
    <>
      <HeroMobile
        t={t}
        dir={dir}
        routes={routes}
        UI={UI}
        bg="/images/hero2.jpg"
        logo="/images/logo.svg"
        star="/images/star.svg"
        showStar
        showLangToggle
        toggleLabel={t.nav.toggle}
        onToggleLang={onToggleLang}
      />

      {/* CTAs BELOW the hero */}
      <section style={{ marginTop: 12 }}>
        <div
          style={{
            display: "grid",
            gap: 10,
            width: "min(360px, 92vw)",
            margin: "0 auto",
          }}
        >
          <a
            href={routes.floors || "#floors"}
            style={{
              display: "block",
              background: UI.garnet,
              color: "#fff",
              padding: "12px 14px",
              borderRadius: 12,
              textDecoration: "none",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            {t?.ctaPrimary}
          </a>
          <a
            href={routes.contact || "#contact"}
            style={{
              display: "block",
              background: UI.teal,
              color: "#fff",
              padding: "12px 14px",
              borderRadius: 12,
              textDecoration: "none",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            {t?.ctaSecondary}
          </a>
        </div>
      </section>

      {/* Features */}
      <section style={{ marginTop: 12 }}>
        <div style={{ display: "grid", gap: 10 }}>
          {t.features.map((it, i) => (
            <div key={i} style={{ border: `1px solid ${UI.border}`, borderRadius: 14, padding: 14, background: "#fff", color: "#111" }}>
              <div style={{ fontWeight: 700, marginBottom: 4 }}>{it.h}</div>
              <div style={{ color: "#5b6570", fontSize: 13 }}>{it.p}</div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
